import { Component, Prop, h } from '@stencil/core';
import { serviceNumber } from '../../utils/ttarp';
import { desktopBannerMessage, mobileBannerMessage } from '../../constants/constants';
import { setFeatureFlagsFromUrl, signaler } from '../../utils/signaler';

@Component({
  tag: 'ci-header',
  styleUrl: 'ci-header.scss',
})
export class CustominkHeader {
  @Prop() headerFlavor: 'default' | 'simple' = 'default';
  @Prop() serviceNumber: string = serviceNumber;
  @Prop() mobileBannerMessage: string = mobileBannerMessage;
  @Prop() desktopBannerMessage: string = desktopBannerMessage;
  @Prop() signaler = signaler;

  componentWillLoad() {
    setFeatureFlagsFromUrl(this.signaler);
    window.dispatchEvent(new Event('ciHeaderLoaded'));
  }
  render() {
    if (this.headerFlavor == 'simple') return <simple-header serviceNumber={this.serviceNumber} />;
    else return <default-header serviceNumber={this.serviceNumber} mobileBannerMessage={this.mobileBannerMessage} desktopBannerMessage={this.desktopBannerMessage} />;
  }
}
